import React from 'react';
import CourseOutlineTree from './CourseOutlineTree';
import './CourseOutlineRail.css';

/**
 * CourseOutlineRail
 * ------------------
 * Desktop outline rail chrome: tracked "COURSE OUTLINE" label + collapse
 * control, course title, progress bar with a mono percentage, a counts
 * line, then the module tree (mockup 1c, lines 541-603).
 *
 * Sharing is NOT part of this header — the mockup puts "Share lesson" in the
 * app top bar (line 614). CourseLearnView renders it there via <TopbarActions>.
 *
 * The module/section tree itself is CourseOutlineTree, shared with the
 * mobile drawer — see that file for row-state logic.
 */
export default function CourseOutlineRail({
  title,
  outline,
  loadingOutline,
  selectedSectionId,
  localViewed,
  currentLessonId,
  onSectionClick,
  sectionButtonRefs,
  railRef,
  onCollapse,
  progress,
  children,
}) {
  const { percentComplete = 0, currentIndex, totalSections = 0, totalQuizzes = 0, quizzesPassed = 0 } = progress || {};
  const indexLabel = currentIndex != null ? currentIndex : 0;
  const countsLine = totalQuizzes > 0
    ? `${indexLabel} of ${totalSections} lessons · ${quizzesPassed} of ${totalQuizzes} quizzes`
    : `${indexLabel} of ${totalSections} lessons`;

  return (
    <>
      <div className="outline-rail-header">
        <div className="outline-rail-header-top">
          <span className="outline-rail-label">Course outline</span>
          <button
            type="button"
            onClick={onCollapse}
            className="outline-rail-collapse-btn"
            aria-label="Collapse outline"
            title="Collapse outline"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M7 2.6L3.6 6 7 9.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <p className="outline-rail-title" title={title}>{title}</p>
        <div className="outline-rail-progress">
          <div
            className="outline-rail-progress-bar"
            role="progressbar"
            aria-valuenow={percentComplete}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Course progress"
          >
            <div className="outline-rail-progress-fill" style={{ width: `${percentComplete}%` }} />
          </div>
          <span className="outline-rail-progress-pct">{percentComplete}%</span>
        </div>
        <p className="outline-rail-counts">{countsLine}</p>
      </div>

      <div ref={railRef} className="outline-rail-scroll">
        {children}
        <CourseOutlineTree
          outline={outline}
          loadingOutline={loadingOutline}
          selectedSectionId={selectedSectionId}
          localViewed={localViewed}
          currentLessonId={currentLessonId}
          onSectionClick={onSectionClick}
          sectionButtonRefs={sectionButtonRefs}
        />
      </div>
    </>
  );
}
